<script setup>
// NOTICE: KAPTION-INTEGRATION
// Toggle pill for switching between list and kanban views
// Glassmorphism style matching KaptionActionPill

defineProps({
  isDarkMode: {
    type: Boolean,
    default: false,
  },
  isKanbanActive: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);
</script>

<template>
  <button
    class="kanban-toggle-pill"
    :class="isDarkMode ? 'pill-glass-dark' : 'pill-glass-light'"
    :title="isKanbanActive ? 'Switch to list view' : 'Switch to kanban view'"
    @click="emit('toggle')"
  >
    <i
      class="size-5 transition-all duration-200"
      :class="[
        isKanbanActive ? 'i-lucide-list' : 'i-lucide-kanban',
        isDarkMode
          ? 'text-kpt-text-primary-dark'
          : 'text-kpt-text-primary-light',
      ]"
    />
  </button>
</template>

<style scoped lang="scss">
.kanban-toggle-pill {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 9999px;
  cursor: pointer;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  border: none;
  padding: 0;

  &:hover {
    transform: scale(1.08);
  }

  &:active {
    transform: scale(0.95);
  }

  &:focus-visible {
    outline: 2px solid rgba(99, 102, 241, 0.5);
    outline-offset: 2px;
  }
}

.pill-glass-dark {
  background: rgba(30, 32, 34, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.pill-glass-light {
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}
</style>
